import { Globe, Phone, Mail, MessageSquare, MessageCircle } from 'lucide-react';

/* Sprint 58.1 — shared channel glyph set for the unified Conversations
 * panel (and, going forward, LeadSources/Trigger Center wherever a channel
 * needs a recognizable mark). lucide-react dropped brand/logo icons a few
 * versions ago, so WhatsApp/Messenger/Instagram/TikTok/X/LinkedIn are small
 * inline monochrome glyphs (currentColor, no brand-color lock-in) instead
 * of lucide imports that would fail to resolve. */

function WhatsAppGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 1.67c2.19 0 4.24.85 5.79 2.4a8.2 8.2 0 0 1 2.4 5.79c0 4.52-3.68 8.2-8.2 8.2a8.2 8.2 0 0 1-4.15-1.13l-.3-.17-3.12.82.83-3.04-.19-.31a8.15 8.15 0 0 1-1.25-4.37c0-4.53 3.68-8.2 8.19-8.2Zm-4.5 4.32c-.15 0-.4.06-.61.3-.21.24-.8.79-.8 1.92 0 1.13.82 2.22.93 2.38.12.15 1.6 2.52 3.96 3.42 1.96.75 2.36.6 2.78.56.42-.04 1.37-.56 1.56-1.1.19-.55.19-1.02.13-1.11-.06-.1-.21-.16-.44-.28-.24-.12-1.37-.68-1.58-.75-.21-.08-.37-.12-.52.12-.15.24-.6.75-.73.9-.14.15-.27.17-.5.06-.24-.12-1-.37-1.9-1.18-.7-.63-1.18-1.4-1.31-1.64-.14-.24-.01-.37.1-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.52-1.28-.72-1.75-.19-.46-.38-.4-.52-.4Z"/>
    </svg>
  );
}

function MessengerGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2C6.48 2 2 6.15 2 11.27c0 2.9 1.44 5.49 3.7 7.19V22l3.38-1.86c.9.25 1.87.39 2.92.39 5.52 0 10-4.15 10-9.27C22 6.15 17.52 2 12 2Zm1 12.5-2.55-2.72-4.98 2.72 5.48-5.82L13.5 11.4l4.98-2.72L13 14.5Z"/>
    </svg>
  );
}

function InstagramGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TikTokGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M16.6 2h-3.2v13.6a2.9 2.9 0 1 1-2.1-2.79V9.5a6.1 6.1 0 1 0 5.3 6.05V8.2a7.6 7.6 0 0 0 4.4 1.4V6.4a4.4 4.4 0 0 1-4.4-4.4Z"/>
    </svg>
  );
}

function XGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.9 2H22l-7.2 8.24L23.3 22h-6.6l-5.2-6.8L5.5 22H2.4l7.7-8.8L1.4 2h6.8l4.7 6.2Zm-1.2 18h1.8L7.3 3.9H5.4Z"/>
    </svg>
  );
}

function LinkedInGlyph(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5ZM.24 8.25h4.5V23H.24ZM8.44 8.25h4.31v2.01h.06c.6-1.14 2.06-2.34 4.24-2.34 4.53 0 5.37 2.98 5.37 6.86V23h-4.5v-6.36c0-1.52-.03-3.47-2.11-3.47-2.12 0-2.44 1.65-2.44 3.36V23h-4.5Z"/>
    </svg>
  );
}

export const CHANNEL_META = {
  whatsapp: { label: 'WhatsApp', icon: WhatsAppGlyph, color: '#25D366' },
  messenger: { label: 'Messenger', icon: MessengerGlyph, color: '#0084FF' },
  instagram: { label: 'Instagram', icon: InstagramGlyph, color: '#E1306C' },
  // Distinct label from 'messenger'/'instagram' (private DMs) — these are
  // PUBLIC comment threads on a post, a different reply mechanism (Comments
  // API, never Messages API) and a different mental model for the agent.
  facebook_wall: { label: 'Comentario de Facebook', icon: MessengerGlyph, color: '#0084FF' },
  instagram_wall: { label: 'Comentario de Instagram', icon: InstagramGlyph, color: '#E1306C' },
  tiktok: { label: 'TikTok', icon: TikTokGlyph, color: '#000000' },
  x: { label: 'X', icon: XGlyph, color: '#000000' },
  linkedin: { label: 'LinkedIn', icon: LinkedInGlyph, color: '#0A66C2' },
  web_chat: { label: 'Chat web', icon: Globe, color: '#0F172A' },
  voice: { label: 'Llamadas', icon: Phone, color: '#0F172A' },
  sms: { label: 'SMS', icon: MessageSquare, color: '#0F172A' },
  email: { label: 'Correo', icon: Mail, color: '#0F172A' },
};

// Hotfix 2026-07-19 — DM and wall-comment variants of the same network
// (facebook_wall vs messenger, instagram_wall vs instagram) rendered the
// EXACT same glyph and color, distinguishable only by a hover tooltip —
// invisible at the small icon-only sizes used in the filter bar/chip row.
// A network's brand mark must stay recognizable at a glance (that's the
// whole point of the glyph), so the fix stacks a small neutral "comment
// thread" badge in the corner for wall/comment channels instead of
// changing the base glyph or color — same pattern TikTok/LinkedIn's own
// DM vs comment split will reuse once those ingestion pipelines exist.
const WALL_SUFFIX = '_wall';

export function ChannelIcon({ channel, active = true, className = 'w-3.5 h-3.5', title }) {
  const meta = CHANNEL_META[channel] || CHANNEL_META.web_chat;
  const Icon = meta.icon;
  const isWallComment = typeof channel === 'string' && channel.endsWith(WALL_SUFFIX);
  const color = active ? meta.color : '#CBD5E1';

  if (!isWallComment) {
    return (
      <Icon className={className} style={{ color }} title={title || meta.label} />
    );
  }

  return (
    <span className={`relative inline-flex ${className}`} title={title || meta.label}>
      <Icon className="w-full h-full" style={{ color }} />
      <span
        className="absolute -bottom-[15%] -right-[15%] rounded-full flex items-center justify-center"
        style={{ width: '58%', height: '58%', background: active ? '#fff' : '#F8FAFC', boxShadow: '0 0 0 1.5px currentColor', color }}
      >
        <MessageCircle className="w-full h-full p-[12%]" strokeWidth={3} />
      </span>
    </span>
  );
}

export default CHANNEL_META;
